/**
 *	Search bar functionality.
 */

const searchHandle = function() {
	const $searchTrigger = $('.js-search-trigger');
	const $search = $('.js-search');

	if( ! $searchTrigger.length || ! $search.length) {
		return;
	}

	$searchTrigger.on('click', function() {
		$search.addClass('is-visible').find('.search__field').get(0).focus();
	});

	$search.find('.search__field').on('blur', function() {
		const $searchField = $search.find('.search__field')

		if($searchField.val() !== '') {
			return;
		}

		$search.removeClass('is-visible');
	})
}

searchHandle();
